export const STRINGS_CADERNOLPMA = {
    NAV_CADERNO_LPMA: "Caderno LPMA",
    NAV_REGISTRO_CADERNO_LPMA: "Registros",

    SEARCH_CADERNO_LPMA: "Preenchimento de caderno de LPMA",
    REGISTER_CADERNO_LPMA: "Cadastro de caderno LPMA",
    EDITION_CADERNO_LPMA: "Edição de caderno LPMA ",

    BLOCK_ONE: "1. Dados principais",
    BLOCK_TWO: "2. Sementes para ensaio(s)",
    BLOCK_THREE: "3. Registros de Visitas",
    BLOCK_FOUR: "4. Plantio",
    BLOCK_FIVE: "5. Cultivo",
    BLOCK_SIX: "6. Colheita",
    BLOCK_SEVEN: "7. Monitoramento",
    BLOCK_EIGHT: "8. Destruição",
    BLOCK_NINE: "9. Amostragem",
    BLOCK_TEN: "10. Avaliações Agronômicas",
    BLOCK_ELEVEN: "11. Destruição Bordadura",
    BLOCK_TWELVE: "12. Plantio de Outra Cultura",
    BLOCK_THIRTEEN: "13. Extensão de Monitoramento",
    BLOCK_FOURTEEN: "14. Reportes e Relatórios",
    BLOCK_FIFTEEN: "15. Anotações",
    BLOCK_SIXTEEN: "16. Assinatura",

    TRANSPORTE_MODAL_TITLE: "Origem das Sementes e Cadeia de Custódia",
    REGISTROVISITAS_MODAL_TITLE: "Registro de Visitas",
    PLANTIOS_MODAL_TITLE: "Formulário de Plantio",
    CULTIVOS_MODAL_TITLE: "Formulário de Cultivo",
    COLHEITAS_MODAL_TITLE: "Formulário de Colheita",
    MONITORAMENTOS_MODAL_TITLE: "Formulário de Monitoramento",
    DESTRUICAO_MODAL_TITLE: "Formulário de Destruição/Descarte",
    AMOSTRAGENS_MODAL_TITLE: "Formulário de Amostragem",
    AVALIACAOAGRONOMICA_MODAL_TITLE: "Formulário de Avaliação Agronômica",
    AVALIACOES_AGRONOMICAS_MODAL_TITLE: "Formulário de Avaliações Agronômicas",
    DESTRUICAOBORDADURA_MODAL_TITLE: "Formulário de Destruição de Bordadura",
    PLANTIOOUTRACULTURA_MODAL_TITLE: "Formulário de Plantio de Outra Cultura",
    EXTENSAOMONITORAMENTO_MODAL_TITLE: "Formulário de Extensão de Monitoramento",
    REPORTES_MODAL_TITLE: "Formulário de Reportes e Relatórios",
    ANOTACOES_MODAL_TITLE: "Formulário de Anotações",
    ASSINATURAS_MODAL_TITLE: "Formulário de Assinatura",

    EDITION_REGISTER_CONFIRMATION_CANCEL: "Todos os dados informados serão perdidos. Tem certeza que deseja cancelar?",
    EDITION_TITLE_CONFIRMATION: "Tem certeza?",
    CONFIRM_LEFT_EDITION: "Sim, voltar",
    CANCEL_LEFT_EDITION: "Não, permanecer",

}